import Highcharts from "highcharts/highstock";
const stopEvent = (e) => {
    if (e.preventDefault) {
        e.preventDefault();
    }
    if (e.stopPropagation) {
        e.stopPropagation();
    }
};
const setExtreme = (axis, delta) => {
    const extr = axis.getExtremes(), spacing = extr.max - extr.min, step = (extr.max - extr.min) / 5 * delta;
    if (step < 0) {
        const newMin = Math.max(extr.dataMin, extr.min + step);
        axis.setExtremes(newMin, newMin + spacing, true, false);
    }
    else {
        const newMax = Math.min(extr.dataMax, extr.max + step);
        axis.setExtremes(newMax - spacing, newMax, true, false);
    }
};
const doScroll = (event, chart) => {
    const [axis] = chart.xAxis, e = chart.pointer.normalize(event);
    const delta = (e.detail || -(event.deltaY / 100)) < 0 ? 1 : -1;
    if (axis?.options?.scrollbar?.enabled &&
        (chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop) ||
            chart.isInsidePlot(e.chartX, e.chartY - chart.plotTop))) {
        setExtreme(axis, delta);
        stopEvent(event);
        return false;
    }
    return true;
};
export const ManageScroll = function ManageScroll(proceed) {
    proceed.call(this);
    Highcharts.addEvent(this.container, window.onmousewheel ? "DOMMouseScroll" : "mousewheel", (event) => doScroll(event, this));
};
